import React, { useEffect, useMemo, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link, useLocation } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { createPolicy, updatePolicy, deletePolicy, fetchPolicyLog, } from "../../../core/data/redux/policy/policyAction";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { fetchAllDepartments } from "../../../core/data/redux/department/departmentAction";
import { fetchAllPolicies, fetchPolicyById, } from "../../../core/data/redux/policy/policyAction";
import DeleteModal1 from "../../../core/modals/deleteModal1";
import { exportToCSV, exportToExcel, exportToPDF, } from "../../../core/common/GlobalFunctions/exportTableData";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { Drawer, message } from "antd";
import { status } from "../../../core/common/selectoption/selectoption";
import { FetchAllPolicyCategory } from "../../../core/data/redux/policyCategory/policyCategoryAction";
import { formatDate } from "../../../core/utils/configFormatters";
import { useAppConfig } from "../../../customhooks/useAppConfig";
import { filterByStatus } from "../../../core/utils/filterActiveData";
import { decryptData } from "../../../core/utils/encryptUtils";
import { getEmployees } from "../../../core/data/redux/employee/employeeAction";
import { fetchAllBranch } from "../../../core/data/redux/branch/branch.Action";
import Select from "react-select";

const Policy = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedSort, setSelectedSort] = useState<any>("");
  const [tableKey, setTableKey] = useState(0);
  const { user } = useSelector((state: any) => state.auth);
  const { departments } = useSelector((state: any) => state.department);
  const { branch } = useSelector((state: any) => state.branch);
  const { policies, loading } = useSelector((state: any) => state.policy);
  const departementData = departments ? departments : [];
  const [isEditing, setIsEditing] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [modalType, setModalType] = useState<"edit" | "create" | 'log' | "">("");
  const [selectedRowData, setSelectedRowData] = useState<any>();
  const policyId = selectedRowData?.Id;
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const activeDepartments = filterByStatus(departementData, 'active', 'Status');
  const activeBranch = filterByStatus(branch, 'active', 'Status');
  const { employees } = useSelector((state: any) => state.employee);
  const [selectAll, setSelectAll] = useState(false);

  const { policyLog } = useSelector((state: any) => state.policy);
  const { employeesbyUser } = useSelector((state: any) => state.employee);
  const employeeId = employeesbyUser?.employeeId;

  useEffect(() => {
    dispatch(fetchPolicyLog(policyId));
  }, [dispatch, policyId])
  console.log(policyId, 'policy id')

  console.log(policyLog, 'policy logs')

  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];


  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");
  const canExport =
    permissions.includes("Export") || permissions.includes("AllowAll");

  const handleEditPolicy = (record: any): void => {
    setIsEditing(true);
    setSelectedRowData(record);

    setFormData({
      Name: record.Name || "",
      Description: record.Description || "",
      SelectedType: record.SelectedType || "",
      SelectedTypeId: record.SelectedTypeId || "",
      EffectiveDate: record.EffectiveDate
        ? record.EffectiveDate.split("T")[0]
        : "",
      Status: record.Status || "active",
      CreatedBy: user?.UserId,
      file: record.PolicyDocURL
        ? { name: record.PolicyDocName || record.PolicyDocURL.split("/").pop() }
        : null,
      IsPublic: record.public === 1 ? true : false,
      PrivateAccessOptions: Array.isArray(record?.privateAccess)
        ? record.privateAccess
        : typeof record?.privateAccess === "string"
          ? record.privateAccess.split(",")
          : [],
    });
  };



  const [formData, setFormData] = useState<any>({
    Name: "",
    Description: "",
    SelectedType: "",
    SelectedTypeId: "",
    EffectiveDate: "",
    Status: "active",
    CreatedBy: user?.UserId,
    file: null,
    IsPublic: true,
    PrivateAccessOptions: [],
  });



  const [errors, setErrors] = useState<any>({
    Name: "",
    Description: "",
    SelectedType: "",
    SelectedTypeId: "",
    EffectiveDate: "",
    Status: "",
    PrivateAccessOptions: [],
  });

  useEffect(() => {
    if (departementData.length === 0) {
      dispatch(fetchAllDepartments());
    }
    dispatch(getEmployees());
    dispatch(fetchAllBranch());
  }, [dispatch]);






  const handleChange = (e: any) => {
    const { name, files, value, type } = e.target;

    if (name === "file") {
      const file = files[0];
      if (file && file.type !== "application/pdf") {
        message.warning("Only PDF files are allowed.");
        return;
      }
      setFormData((prev: any) => ({ ...prev, file }));
    } else {
      // convert string "true"/"false" to boolean if needed
      let newValue: any = value;
      if (name === "IsPublic") {
        newValue = value === "true";
      }

      setFormData((prev: any) => ({
        ...prev,
        [name]: newValue,
      }));
    }
  };


  // useEffect(() => {
  //   setSelectAll(false);
  // }, [formData.SelectedType]);





  const handleDeletePolicy = async (policyId: any) => {
    try {
      const resp = await dispatch(deletePolicy({ policyId }));
      if (resp.meta.requestStatus === "fulfilled") {
        setIsDeleteModalVisible(false);
        message.success(resp.payload.message);
        await dispatch(fetchAllPolicies());
        setTableKey((prevKey) => prevKey + 1);
      } else {
        setIsDeleteModalVisible(false);
        message.error(resp.payload.message);
      }
    } catch (error: any) {
      message.error("error is ", error);
    }
  };
  const resetForm = () => {
    setFormData({
      Name: "",
      Description: "",
      PolicyCategoryId: "",
      EffectiveDate: "",
      DepartmentId: "",
      CreatedBy: user?.UserId,
      file: null,
      Status: "active",
      PrivateAccessOptions: [],
    });
    setErrors({
      Name: "",
      Description: "",
      PolicyCategoryId: "",
      EffectiveDate: "",
      DepartmentId: "",
      file: "",
      Status: "",
      PrivateAccessOptions: [],
    });
  };

  const showModal = (type: "edit" | "create" | "log") => {
    setModalType(type);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setModalType("");
    resetForm();
  };

  const validateForm = () => {
    const newErrors: any = {};

    if (!formData.Name?.trim()) {
      newErrors.Name = "Policy name is required.";
    }

    if (!formData.SelectedType) {
      newErrors.SelectedType = "Please select a category type.";
    }

    if (
      ["Department", "Branch", "Employee"].includes(formData.SelectedType) &&
      (!formData.SelectedTypeId || formData.SelectedTypeId === "")
    ) {
      newErrors.SelectedTypeId = `Please select a ${formData.SelectedType.toLowerCase()}.`;
    }

    if (!formData.EffectiveDate) {
      newErrors.EffectiveDate = "Effective date is required.";
    }

    if (!formData.Status) {
      newErrors.Status = "Status is required.";
    }

    if (!formData.file) {
      newErrors.file = "Policy document is required.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const onsubmit = async (e: any) => {
    try {
      e.preventDefault();
      const isValid = validateForm();
      if (!isValid) return;


      const payload = {
        Name: formData.Name,
        Description: formData.Description,
        SelectedType: formData.SelectedType,
        SelectedTypeId: formData.SelectedTypeId,
        EffectiveDate: formData.EffectiveDate,
        Status: formData.Status,
        IsPublic: formData.IsPublic,
        file: formData.file,
        ...(modalType === "edit"
          ? { modifiedBy: user?.UserId }
          : { createdBy: user?.UserId }),
        PrivateAccess: formData.PrivateAccessOptions
      };



      if (modalType === "edit") {

        const resp = await dispatch(updatePolicy({ policyId, ...payload }));
        if (resp.meta.requestStatus === "fulfilled") {
          message.success("Updated Successfully");
          await dispatch(fetchAllPolicies());
          resetForm();
          setTableKey((prevKey) => prevKey + 1);
        }
      } else {
        const resp = await dispatch(createPolicy(payload));
        if (resp.meta.requestStatus === "fulfilled") {
          message.success(resp.payload.message);
          await dispatch(fetchAllPolicies());
        } else {
          message.warning(resp.payload.error);
        }
        resetForm();
        setTableKey((prevKey) => prevKey + 1);
      }
      handleCancel();
    } catch (error: any) {
      message.error("Error submitting form:", error);
    }
  };

  ///fetching the data
  useEffect(() => {
    if (!policies.length) {
      dispatch(fetchAllPolicies());
    }
  }, [dispatch, policies.length]);

  useEffect(() => {
    if (policyId) {
      dispatch(fetchPolicyById({ policyId }));
    }
  }, [dispatch, policyId, selectedRowData]);

  const data = policies ? policies : [];

  const exportPolicies = data.map((policy: any) => ({
    PolicyId: policy.Id,
    Name: policy.Name,
    Description: policy.Description,
    PolicyCategory: policy.SelectedType,
    "Applied On": policy.SelectedTypeName,
    CreatedDate: new Date(policy.CreatedAt).toLocaleDateString("en-IN"),
    EffectiveDate: policy.EffectiveDate ? new Date(policy.EffectiveDate).toLocaleDateString("en-IN") : "",
    Status: policy.Status,
  }))

  const privateOptions = [
    { label: "View", value: "view" },
    { label: "Download", value: "download" },
  ];


  const filteredData = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { Status: selectedStatus }
        : {};
    return filterData(
      policies || [],
      filters,
      "CreatedAt",
      "CreatedAt",
      selectedSort
    );
  }, [policies, selectedStatus, selectedSort]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [selectedStatus, selectedSort, policies]);

  const config = useAppConfig();
  if (!config) return null;

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      render: (text: string, record: any) => (
        <Link to={all_routes.policydetails.replace(":policyId", record.Id)}>
          <h6
            className="fw-medium fs-14 text-primary mb-0"
            style={{ textDecoration: "underline", cursor: "pointer" }}
          >
            {text}
          </h6>
        </Link>
      ),
      sorter: (a: any, b: any) => a.Name.length - b.Name.length,
    },
    {
      title: "Category Type",
      dataIndex: "SelectedType",
      sorter: (a: any, b: any) =>
        a.SelectedType.length - b.SelectedType.length,
    },
    {
      title: "Applied On",
      dataIndex: "SelectedTypeName",
      render: (_: any, record: any) => {
        if (record.SelectedType === "Employee") {
          const count = record.SelectedTypeId
            ? record.SelectedTypeId.split(",").filter(Boolean).length
            : 0;

          return `${count} Employees`;
        }

        return record.SelectedTypeName;
      },
      sorter: (a: any, b: any) => {
        if (a.SelectedType === "Employee" && b.SelectedType === "Employee") {
          return (
            a.SelectedTypeId.split(",").length -
            b.SelectedTypeId.split(",").length
          );
        }
        return (a.SelectedTypeName || "").length - (b.SelectedTypeName || "").length;
      },
    },
    {
      title: "Effective Date",
      dataIndex: "EffectiveDate",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => {
        const dateA = new Date(a.EffectiveDate);
        const dateB = new Date(b.EffectiveDate);
        return dateA.getTime() - dateB.getTime();
      },
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: any) => {
        const status = text ? text.charAt(0).toUpperCase() + text.slice(1) : "N/A";
        return (
          <span
            className={`badge ${text === "active" ? "badge-success" : "badge-danger"
              } d-inline-flex align-items-center badge-xs`}
          >
            <i className="ti ti-point-filled me-1" />
            {status}
          </span>
        );
      },
      sorter: (a: any, b: any) => (a.Status || "").length - (b.Status || "").length,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">
          {/* Edit Button */}
          <button
            className="me-2"
            onClick={() => {
              if (!canEdit) return;
              showModal("edit");
              handleEditPolicy(record);
            }}
            disabled={!canEdit}
            style={{
              cursor: canEdit ? "pointer" : "not-allowed",
              opacity: canEdit ? 1 : 0.5,
            }}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={!canEdit ? "Permission Denied" : "Edit Policy"}
          >
            <i className="ti ti-edit" />
          </button>

          {/* Delete Button */}
          <button
            onClick={() => {
              if (!canDelete || record.Status === "inactive") return;
              setSelectedRowData(record);
              setIsDeleteModalVisible(true);
            }}
            disabled={!canDelete || record.Status === "inactive"}
            style={{
              cursor:
                !canDelete || record.Status === "inactive"
                  ? "not-allowed"
                  : "pointer",
              opacity: !canDelete || record.Status === "inactive" ? 0.5 : 1,
            }}
            className="btn-icon me-2"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={
              !canDelete
                ? "Permission Denied"
                : record.Status === "inactive"
                  ? "Policy is inactive"
                  : "Delete Policy"
            }
          >
            <i className="ti ti-trash" />

          </button>

          <button
            onClick={() => {
              if (!canEdit) return;
              dispatch(fetchPolicyLog(policyId));
              showModal("log");
              handleEditPolicy(record);
            }}
            disabled={!canEdit}
            style={{
              cursor: canEdit ? "pointer" : "not-allowed",
              opacity: canEdit ? 1 : 0.5,
            }}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={!canEdit ? "Permission Denied" : "Edit Policy"}
          >
            <i className="bi bi-clock" />
          </button>
        </div>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Policies</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="index.html">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  {/* <li className="breadcrumb-item">HR</li> */}
                  <li className="breadcrumb-item active" aria-current="page">
                    Policies
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {canExport && (
                <div className="me-2 mb-2">
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-file-export me-1" />
                      Export
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <button
                          onClick={() => exportToCSV(exportPolicies, "policy_data")}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as CSV
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => exportToExcel(exportPolicies, "policy_data")}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() => exportToPDF(exportPolicies, "policy_data")}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as PDF{" "}
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              {canAdd && (
                <div className="mb-2">
                  <button
                    className="btn btn-primary d-flex align-items-center"
                    onClick={() => showModal("create")}
                    title="Add Policy"
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Policy
                  </button>
                </div>
              )}

              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Policy list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Policy List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                      selectedStatus.slice(1)
                      : "Select Status"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("All")}
                        className="dropdown-item rounded-1"
                      >
                        All
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("active")}
                        className="dropdown-item rounded-1"
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("inactive")}
                        className="dropdown-item rounded-1"
                      >
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
          {/* /Policylist list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Policy */}
        <Drawer
          title={modalType === "edit" ? "Edit Policy" : modalType === "log" ? "Policy Log" : "Add Policy"}
          placement="right"
          width={400}
          onClose={handleCancel}
          visible={isModalVisible}
          style={{ marginTop: 50, paddingBottom: 50 }}
        >
          {modalType === "log" ? (
            <div>
              {policyLog?.length ? (
                <div className="policy-log-list">
                  {policyLog
                    .filter((log: any) => log.policy_id === selectedRowData?.Id)
                    .map((log: any) => (
                      <div
                        key={log.log_id}
                        className="p-3 mb-2 rounded shadow-sm bg-light border"
                      >
                        <h6 className="mb-1 text-primary fw-semibold">
                          {log.Name || selectedRowData?.Name}
                        </h6>
                        <p className="mb-1 text-muted fs-13">
                          <i className="bi bi-person me-1" />
                          {log.employee_name}
                        </p>
                        <p className="mb-1 fs-13">
                          <i className="bi bi-info-circle me-1 text-secondary" />
                          {log.description}
                        </p>
                        <div className="d-flex justify-content-between align-items-center">
                          <span className="badge bg-success text-white">
                            {log.action_type}
                          </span>
                          <span className="text-muted fs-12">
                            {new Date(log.created_at).toLocaleString()}
                          </span>
                        </div>
                      </div>
                    ))}
                </div>
              ) : (
                <div className="text-center text-muted p-4">
                  <i className="bi bi-inbox fs-1 d-block mb-2" />
                  <p>No logs found for this policy.</p>
                </div>
              )}
            </div>
          ) : (
            <form>
              <div className="modal-body pb-0">
                <div className="row">
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Policy Name <span className="text-danger"> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="Name"
                        value={formData.Name}
                        onChange={handleChange}
                      />
                      {errors.Name && (
                        <div className="text-danger">{errors.Name}</div>
                      )}
                    </div>
                  </div>

                  <div className="col-md-12 mb-3">
                    <label className="form-label">
                      Category Type
                    </label>
                    <div className="d-flex gap-3 flex-wrap">
                      {["Department", "Branch", "Male", "Female", "Employee"].map((type) => (
                        <div className="form-check" key={type}>
                          <input
                            className="form-check-input"
                            type="radio"
                            name="SelectedType"
                            id={type}
                            value={type}
                            checked={formData.SelectedType === type}
                            onChange={handleChange}
                          />
                          <label className="form-check-label" htmlFor={type}>
                            {type}
                          </label>
                        </div>
                      ))}
                    </div>
                    {errors.SelectedType && (
                      <div className="text-danger">{errors.SelectedType}</div>
                    )}
                  </div>


                  {formData.SelectedType === "Department" && (
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Applied On</label>

                        {/* Select All Checkbox */}
                        <div className="d-flex align-items-center gap-2 mb-1">
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setSelectAll(checked);

                              if (checked) {
                                // select all departments
                                const allIds = activeDepartments.map((d: any) => d.Id);
                                setFormData((prev: any) => ({ ...prev, SelectedTypeId: allIds }));
                              } else {
                                // unselect all
                                setFormData((prev: any) => ({ ...prev, SelectedTypeId: [] }));
                              }
                            }}
                          />
                          <label>Select All</label>
                        </div>

                        <Select
                          isMulti
                          name="SelectedTypeId"
                          options={activeDepartments
                            ?.slice()
                            .sort((a: any, b: any) => a.Name.localeCompare(b.Name))
                            .map((dept: any) => ({
                              label: dept.Name,
                              value: dept.Id,
                            }))}
                          value={activeDepartments
                            ?.filter((dept: any) =>
                              (formData.SelectedTypeId || []).includes(dept.Id)
                            )
                            .map((dept: any) => ({
                              label: dept.Name,
                              value: dept.Id,
                            }))}
                          onChange={(selectedOptions: any) => {
                            const selectedValues = selectedOptions.map((opt: any) => opt.value);

                            setFormData((prev: any) => ({
                              ...prev,
                              SelectedTypeId: selectedValues,
                            }));

                            // if user unselects something manually, uncheck Select All
                            if (selectedValues.length !== activeDepartments.length) {
                              setSelectAll(false);
                            } else {
                              setSelectAll(true);
                            }
                          }}
                          placeholder="Select Department(s)..."
                        />
                      </div>
                    </div>
                  )}


                  {formData.SelectedType === "Branch" && (
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Applied On</label>

                        {/* Select All Checkbox */}
                        <div className="d-flex align-items-center gap-2 mb-1">
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setSelectAll(checked);

                              if (checked) {
                                // Select all branch IDs
                                const allIds = activeBranch.map((b: any) => b.Id);
                                setFormData((prev: any) => ({ ...prev, SelectedTypeId: allIds }));
                              } else {
                                // Unselect all
                                setFormData((prev: any) => ({ ...prev, SelectedTypeId: [] }));
                              }
                            }}
                          />
                          <label>Select All</label>
                        </div>

                        <Select
                          isMulti
                          name="SelectedTypeId"
                          options={[...activeBranch]
                            .sort((a: any, b: any) =>
                              a.Branch_Name.localeCompare(b.Branch_Name)
                            )
                            .map((branch: any) => ({
                              label: branch.Branch_Name,
                              value: branch.Id,
                            }))}
                          value={activeBranch
                            ?.filter((branch: any) =>
                              (formData.SelectedTypeId || []).includes(branch.Id)
                            )
                            .map((branch: any) => ({
                              label: branch.Branch_Name,
                              value: branch.Id,
                            }))}
                          onChange={(selectedOptions: any) => {
                            const selectedValues = selectedOptions.map((opt: any) => opt.value);

                            setFormData((prev: any) => ({
                              ...prev,
                              SelectedTypeId: selectedValues,
                            }));

                            // auto-control Select All state
                            if (selectedValues.length !== activeBranch.length) {
                              setSelectAll(false);
                            } else {
                              setSelectAll(true);
                            }
                          }}
                          placeholder="Select Branch(es)..."
                        />
                      </div>
                    </div>
                  )}


                  {formData.SelectedType === "Employee" && (
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Applied On</label>

                        {/* Select All Checkbox */}
                        <div className="d-flex align-items-center gap-2 mb-1">
                          <input
                            type="checkbox"
                            checked={selectAll}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setSelectAll(checked);

                              if (checked) {
                                // Select all employee IDs
                                const allIds = employees.map((emp: any) => emp.EmployeeID);
                                setFormData((prev: any) => ({ ...prev, SelectedTypeId: allIds }));
                              } else {
                                // Unselect all
                                setFormData((prev: any) => ({ ...prev, SelectedTypeId: [] }));
                              }
                            }}
                          />
                          <label>Select All</label>
                        </div>

                        <Select
                          isMulti
                          name="SelectedTypeId"
                          options={[...employees]
                            .sort((a: any, b: any) =>
                              `${a.FirstName} ${a.LastName}`.localeCompare(
                                `${b.FirstName} ${b.LastName}`
                              )
                            )
                            .map((emp: any) => ({
                              label: `${emp.FirstName} ${emp.LastName}`,
                              value: emp.EmployeeID,
                            }))}
                          value={employees
                            ?.filter((emp: any) =>
                              (formData.SelectedTypeId || []).includes(emp.EmployeeID)
                            )
                            .map((emp: any) => ({
                              label: `${emp.FirstName} ${emp.LastName}`,
                              value: emp.EmployeeID,
                            }))}
                          onChange={(selectedOptions: any) => {
                            const selectedValues = selectedOptions.map((opt: any) => opt.value);

                            setFormData((prev: any) => ({
                              ...prev,
                              SelectedTypeId: selectedValues,
                            }));

                            // auto-control Select All state
                            if (selectedValues.length !== employees.length) {
                              setSelectAll(false);
                            } else {
                              setSelectAll(true);
                            }
                          }}
                          placeholder="Select Employee(s)..."
                        />
                      </div>
                    </div>
                  )}



                  {errors.SelectedTypeId && (
                    <div className="text-danger">{errors.SelectedTypeId}</div>
                  )}

                  <div className="mb-3">
                    <label className="form-label">
                      Effective Date <span className="text-danger"> *</span>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      value={formData.EffectiveDate?.split("T")[0] || ""}
                      onChange={(e) =>
                        setFormData((prev: any) => ({
                          ...prev,
                          EffectiveDate: e.target.value,
                        }))
                      }
                    />
                    {errors.EffectiveDate && (
                      <div className="text-danger">{errors.EffectiveDate}</div>
                    )}
                  </div>

                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Status <span className="text-danger"> *</span>
                      </label>
                      <select
                        name="Status"
                        id="Status"
                        value={formData.Status}
                        onChange={handleChange}
                        required
                        className="form-control w-full border p-2 rounded-lg"
                      >
                        {status.map((s: any) => (
                          <option key={s.value} value={s.value}>
                            {s.label}
                          </option>
                        ))}
                      </select>
                      {errors.Status && (
                        <div className="text-danger">{errors.Status}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Upload Policy <span className="text-danger"> *</span>
                      </label>
                      <div className="policy-upload d-flex flex-column align-items-center">
                        {formData.file ? (
                          <h6 className="fs-12 fw-normal mb-2">
                            {formData?.file?.name}
                          </h6>

                        ) : (
                          <div className="drag-upload-btn bg-primary mb-0">
                            <i className="ti ti-upload me-1" />
                            Upload
                            <input
                              type="file"
                              accept="application/pdf"
                              className="form-control image-sign"
                              name="file"
                              onChange={handleChange}
                            />
                          </div>
                        )}
                        {errors.file && (
                          <div className="text-danger">{errors.file}</div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="mb-3">
                      <label className="form-label">
                        Description
                      </label>
                      {isEditing ? (
                        <textarea
                          className="form-control"
                          value={formData.Description}
                          onChange={(e) =>
                            setFormData((prev: any) => ({
                              ...prev,
                              Description: e.target.value,
                            }))
                          }
                        />
                      ) : (
                        <textarea
                          className="form-control"
                          value={formData.Description}
                          onChange={(e) =>
                            setFormData((prev: any) => ({
                              ...prev,
                              Description: e.target.value,
                            }))
                          }
                        />
                      )}
                      {errors.Description && (
                        <div className="text-danger">{errors.Description}</div>
                      )}
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="mb-3">
                      <div className="d-flex gap-3 p-3 bg-light rounded">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="IsPublic"
                            id="public"
                            value="true"
                            checked={formData.IsPublic === true}
                            onChange={handleChange}
                          />
                          <label className="form-check-label" htmlFor="public">
                            Public
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="IsPublic"
                            id="private"
                            value="false"
                            checked={formData.IsPublic === false}
                            onChange={handleChange}
                          // disabled={formData.SelectedType === "Employee"}
                          />
                          <label className="form-check-label" htmlFor="private">
                            Private
                          </label>
                        </div>
                      </div>

                    </div>
                  </div>

                  {formData.IsPublic === false && (
                    <div className="mb-3">
                      <label className="form-label">
                        Private Access Options <span className="text-danger">*</span>
                      </label>
                      <Select
                        isMulti
                        options={[
                          { label: "View", value: "view" },
                          { label: "Download", value: "download" },
                        ]}
                        value={
                          [
                            { label: "View", value: "view" },
                            { label: "Download", value: "download" },
                          ].filter((opt) => (formData.PrivateAccessOptions || []).includes(opt.value))
                        }
                        onChange={(selectedOptions: any) => {
                          const selectedValues = selectedOptions.map((opt: any) => opt.value);
                          setFormData((prev: any) => ({
                            ...prev,
                            PrivateAccessOptions: selectedValues,
                          }));
                        }}
                        placeholder="Select access options..."
                        styles={{
                          multiValue: (base: any) => ({
                            ...base,
                            display: "inline-flex",
                            marginRight: "5px",
                          }),
                          multiValueLabel: (base: any) => ({
                            ...base,
                            whiteSpace: "nowrap",
                          }),
                          control: (base: any, state: any) => ({
                            ...base,
                            minHeight: "38px",
                            overflow: "auto",
                            flexWrap: "nowrap",
                            borderColor: "#ced4da",
                            boxShadow: "none",
                            "&:hover": {
                              borderColor: "#ced4da",
                            },
                          }),
                        }}
                      />
                    </div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-white border me-2"
                  onClick={handleCancel}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onsubmit} disabled={loading}
                >{loading && <span className="spinner-border spinner-border-sm me-2" />}
                  {modalType === "edit" ? "Update Policy" : "Add Policy"}
                </button>
              </div>
            </form>
          )}
        </Drawer>

      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() =>
          selectedRowData?.Id && handleDeletePolicy(selectedRowData.Id)
        }
      />

      {/* /Add Policy */}
    </>
  );
};

export default Policy;
